import '@inmotionnow/momentum-components/dist/momentum.css'
import './i18n' // Initialize i18n before app renders

import { defaultTheme, MomentumProvider } from '@inmotionnow/momentum-core'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'

import App from './App.tsx'
import { AuthProvider } from './auth/AuthProvider'
import { store } from './store'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <MomentumProvider theme={defaultTheme}>
      <Provider store={store}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Provider>
    </MomentumProvider>
  </React.StrictMode>,
)
